import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e0681a6c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "slider-row v-ui"
};
const _hoisted_2 = {
  class: "v-ui-area"
};
const _hoisted_3 = {
  class: "track"
};
const _hoisted_4 = {
  class: "bar-wrap"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "thumb-dot"
}, null, -1));
const _hoisted_6 = [_hoisted_5];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "bar",
    style: _normalizeStyle(`transform: scaleX(${$data.barScaleX});`)
  }, null, 4)]), _createElementVNode("div", {
    class: "thumb",
    style: _normalizeStyle(`transform: translateX(${$data.thumbOffsetX}px);`)
  }, _hoisted_6, 4)])])]);
}